import { render } from "./screen-index.vue?vue&type=template&id=51f322ea&scoped=true"
import script from "./screen-index.vue?vue&type=script&lang=js"
export * from "./screen-index.vue?vue&type=script&lang=js"

import "./screen.scss?vue&type=style&index=0&id=51f322ea&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-51f322ea"

export default script